// mantine
import { Button, TextInput, UnstyledButton } from '@mantine/core';
// utils
import { useFormik } from 'formik';
import type { IConnector } from '@newo/api/gateway';
import { useUpdateConnectorMutation } from '@/services/integration/integration.queries.ts';
import validationSchema from '@/pages/Integrations/components/EditConnectorForm/EditConnectorForm.schema.ts';

interface EditConnectorFormProps {
    connector: IConnector;
    onCancel?: () => void;
    onSubmit?: () => void;
}

const EditConnectorForm = ({
    connector,
    onCancel,
    onSubmit
}: EditConnectorFormProps) => {
    const updateConnectorMutation = useUpdateConnectorMutation();
    const initialValues = {
        title: connector.title,
        connector_idn: connector.connector_idn
    };
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit(data) {
            updateConnectorMutation.mutate(
                {
                    connectorId: connector.id,
                    data
                },
                {
                    onSuccess: () => {
                        onSubmit?.();
                        onCancel?.();
                    },
                    onSettled() {
                        formik.setSubmitting(false);
                    }
                }
            );
        }
    });

    const handleCancel = () => {
        onCancel?.();
    };

    return (
        <form
            autoComplete="off"
            className="flex flex-col gap-3"
            onSubmit={formik.handleSubmit}
        >
            <TextInput
                withAsterisk
                error={formik.touched.title ? formik.errors.title : undefined}
                label="Title"
                name="title"
                placeholder="Connector title"
                value={formik.values.title}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
            />
            <div className="flex justify-between gap-2">
                <UnstyledButton
                    className="text-xs text-gray-6"
                    onClick={handleCancel}
                >
                    Cancel
                </UnstyledButton>
                <Button
                    disabled={
                        !formik.dirty || !formik.isValid || formik.isSubmitting
                    }
                    size="xs"
                    type="submit"
                >
                    Save
                </Button>
            </div>
        </form>
    );
};

export default EditConnectorForm;
